import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '@cotyorg/ccx-atoms/Link';
import Button from '@cotyorg/ccx-atoms/Button';
import Heading from '@cotyorg/ccx-atoms/Heading';
import ProductRating from '@cotyorg/ccx-molecules/ProductRating';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';

const generateCardDescriptionClassNames = cardContentDescriptionClassNames =>
  classNames('card__description', {
    [`${cardContentDescriptionClassNames}`]: cardContentDescriptionClassNames,
  });

const generateCardTitleClassNames = isSmallTitle =>
  classNames('card__title', {
    'card__title--small': isSmallTitle,
  });

const CardContent = ({
  tag,
  tagHeadingLevel,
  isTagUnderlined,
  description,
  linkUrl,
  linkText,
  title,
  cardContentClassNames,
  cardContentBoxClassNames,
  cardContentDescriptionClassNames,
  headingLevel,
  isTitleUnderlined,
  isSmallTitle,
  averageRating,
  numberOfReviews,
  imgRatingOnSrc,
  imgRatingOffSrc,
  showStarRating,
  hideDescription,
  openLinkInNewTab,
  fullClickableArea,
  renderCustomRating,
  ratingIconWidth,
  ratingIconHeight,
  bvid,
  slug,
  additionalOnClick,
  additionalButtonText,
}) => (
  <div className={cardContentClassNames}>
    <div className={cardContentBoxClassNames}>
      {tag && (
        <Heading
          level={tagHeadingLevel}
          isUnderlined={isTagUnderlined}
          extraClass="card__tag"
        >
          {tag}
        </Heading>
      )}

      {title && linkUrl && linkText && !fullClickableArea ? (
        <Heading
          level={headingLevel}
          isUnderlined={isTitleUnderlined}
          extraClass={generateCardTitleClassNames(isSmallTitle)}
        >
          <Link
            extraClass="cardo__heading-link"
            link={linkUrl}
            {...(openLinkInNewTab && { target: '_blank' })}
            ><span dangerouslySetInnerHTML={{ __html: title }} />
          </Link>
        </Heading>
      ) : title ? (
        <Heading
          level={headingLevel}
          isUnderlined={isTitleUnderlined}
          extraClass={generateCardTitleClassNames(isSmallTitle)}
        >
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
      ) : null}

      {description && !hideDescription && (
        <p
          className={generateCardDescriptionClassNames(cardContentDescriptionClassNames)}
        >
          <BBCodeParser>{description}</BBCodeParser>
        </p>
      )}

      {linkUrl && linkText && !fullClickableArea ? (
        <p className="card__link-text">
          <Link
            extraClass="card__link"
            link={linkUrl}
            {...(openLinkInNewTab && { target: '_blank' })}
          >
            {linkText}
          </Link>
        </p>
      ) : linkUrl && linkText && fullClickableArea ? (
        <p className="card__link-text link card__link">{linkText}</p>
      ) : null}

      {!renderCustomRating && showStarRating ? (
        <div
          data-bv-show="inline_rating"
          data-bv-product-id={bvid}
          data-bv-seo
        />
      ) : typeof renderCustomRating === 'function' ? (
        renderCustomRating()
      ) : (
      renderCustomRating && (

        <ProductRating
          averageRating={averageRating}
          numberOfReviews={numberOfReviews}
          imgRatingOnSrc={imgRatingOnSrc}
          imgRatingOffSrc={imgRatingOffSrc}
          ratingIconWidth={ratingIconWidth}
          ratingIconHeight={ratingIconHeight}
        />
      ))}

      {additionalButtonText && additionalOnClick && (
      <Button
        testAttribute="card-additional-button-text"
        extraClass="card__additional-button"
        onClick={(e) => {
                  e.preventDefault();
                  additionalOnClick({ slug });
                }}
      >
        {additionalButtonText}
      </Button>
          )}
    </div>
  </div>
);

CardContent.propTypes = {
  cardContentDescriptionClassNames: PropTypes.string,
  tag: PropTypes.string,
  tagHeadingLevel: PropTypes.number,
  isTagUnderlined: PropTypes.bool,
  description: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  title: PropTypes.string,
  cardContentClassNames: PropTypes.string,
  cardContentBoxClassNames: PropTypes.string,
  headingLevel: PropTypes.number,
  isTitleUnderlined: PropTypes.bool,
  isSmallTitle: PropTypes.bool,
  averageRating: PropTypes.number,
  numberOfReviews: PropTypes.number,
  imgRatingOnSrc: PropTypes.string,
  imgRatingOffSrc: PropTypes.string,
  showStarRating: PropTypes.bool,
  hideDescription: PropTypes.bool,
  openLinkInNewTab: PropTypes.bool,
  fullClickableArea: PropTypes.bool,
  renderCustomRating: PropTypes.func,
  ratingIconWidth: PropTypes.number,
  ratingIconHeight: PropTypes.number,
  bvid: PropTypes.string,
  slug: PropTypes.string,
};

export default CardContent;
